import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeInUp" data-wow-delay="0.5s">
            <h1>Terms and Conditions</h1>
          </div>
        </div>
      </section>

      <section className="sub-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Terms and Conditions</span>
          </div>
          <div className="title row wow fadeInUp custom-px">
            <div>
              <p className="company-url">
                <Link to="/" style={{ color: "blue", textDecoration: "underline" }}>
                  slashstar.co
                </Link>{" "}
                is a wholly owned subsidiary of XR Studio LLP.
              </p>
              <p>
                The website (slashstar.co) is provided by Slash Star, a company
                incorporated under the Companies Act, 1956 of India, having its registered
                office at 3002, Silver Business Point, VIP Circle Utran 394105, Surat, Gujarat, India.
              </p>
              <p>
                You hereby agree to accept the terms and conditions set forth in this Terms
                of Use. In any event or situation, if you are not agreeing with these terms
                and conditions, you are requested by Slash Star not to use the website
                or download any material from it.
              </p>
              <p>
                The website, including all the material
                (excluding any applicable third-party materials), is the property of Slash Star,
                and it is copyrighted and protected by worldwide copyright laws and treaty provisions.
                You hereby approve to follow all the copyright laws worldwide in your use of this website
                and to prevent any unauthorized copying of the material.
              </p>
              <p>
                Slash Star is maintaining business relationships with its thousands of customers,
                suppliers, governments, and others. We have used words like joint venture, partnership,
                and partner in order to indicate business relationships involving common activities and
                interests, and words may not indicate precise legal relationships.
              </p>
              <p>
                On a regular basis, this website may also include some links to other websites.
                These links are mainly provided for your convenience to deliver further information.
                They do not signify that we are endorsing this website.
              </p>
              <h4>Copyright and Usage of Property:</h4>
              <p>You may download, view, copy and print documents from the site subject to the following:</p>
              <p>
                The Documents may be used solely for personal, informational, and non-commercial purposes.
              </p>
              <p>
                The Documents may not be modified or altered in any way. Except where your use constitutes
                "fair use" under copyright law, you may not use, download, upload, copy, print, display,
                perform, reproduce, publish, license, post, transmit or distribute any Documents from this
                Site in whole or in part without the express authorization of Slash Star.
              </p>
              <p>
                Unless otherwise stated, the website content is the property of Slash Star. All the trademarks
                used or referred to in this website are the sole property of their respective owners.
              </p>
              <p>
                Elements of Slash Star websites are protected by copyright and other laws and may not be copied
                or imitated in whole or in part. No logo, graphic, sound, or image from the Slash Star website
                may be copied or retransmitted unless expressly permitted by us. All other trademarks and logos
                belong to their respective owners. All rights reserved.
              </p>

              <h4>Use of License:</h4>
              <p>
                Considering the terms and conditions that are set forth in these terms and conditions, Slash Star
                has granted permission to temporarily download the copy of the materials (information or
                services)
                on Slash Star website for personal, non-commercial transitory viewing only. This is the
                grant of a license, not a transfer of title. You also agree that you will not interrupt or
                attempt
                to interrupt the operation of the website in any manner.
              </p>
              <p>
                Unless specified, the website is for your personal and non-commercial use. Ensure that you shall
                not change, modify, copy and distribute, display, perform, reproduce, publish, license, create
                derivative works from, transfer, or sell any information, software, products, or services
                obtained from this website.
              </p>

              <h4>Blogs:</h4>
              <p>
                This is to inform that individuals (including, but not limited to employees of Slash Star and
                referred to as "Individuals") may contribute articles, blog content, and opinions on this
                website which is the sole discretion of Slash Star. Such contributed content and articles
                are referred to as "blogs" because such terms are easily understood. You agree that these
                blogs and contents found the opinion of the individuals in their personal capacity and do
                not signify the official positions of Slash Star. We hold all the copyright to these blog
                contents.
              </p>

              <h4>Disclaimer:</h4>
              <p>
                The information mentioned on this website is for general purposes only. We endeavor to
                keep this information updated and correct. The company does not warrant the accuracy
                or completeness of the materials or the reliability of any advice, opinion, statement,
                or other information that is displayed or distributed through the website.
              </p>
              <p>
                You acknowledge that any reliance on any such opinion, advice, statement, memorandum, or
                information shall be at your sole risk. Slash Star reserves the right, in its sole discretion,
                to correct any errors or omissions in any portion of the website.
              </p>
              <p>
                Slash Star reserves the right to make any other changes to the website, the materials, and the
                products, programs, services, or prices (if any) described on the website at any time without
                any prior notice.
              </p>

              <h4>Unlawful or Prohibited Use of the Website:</h4>
              <p>
                You shall not use the website for any purpose that is unlawful or prohibited by the Terms of Use.
                You are not allowed to
                use the website in any manner that could damage, disable, overburden or impair any Slash Star
                server,
                or the network connected to any Slash Star server.
              </p>
              <p>
                You should not attempt to get unauthorized access to any section of the website, accounts,
                computer systems,
                or networks connected to any Slash Star server, or to any of the services related to the website
                through
                hacking, password mining, or any other manner. Ensure that you do not obtain or attempt to get
                any material
                or information in any way not intentionally made available through the website. In case, if we
                find that you
                have violated this term, we reserve the right to terminate your use of our mobile app
                development service at any time.
              </p>

              <h4>Modifications in Terms of Use:</h4>
              <p>
                Slash Star reserves the right to change, modify, add or remove any portion of the Terms of Use in
                whole or in part,
                at any time. The modification or change in the Terms of Use will be effective once the notice of
                such changes is posted.
                If you are continuing the use of the website after modification in the Terms of Use, it will be
                considered as the
                acceptance of such modifications.
              </p>
              <p>
                Slash Star also reserves the right to change, terminate, suspend or discontinue any service of
                the website,
                including the feature of the service or website anytime without prior notice. Along with this,
                Slash Star
                may also execute limits on features and services. It can also restrict your access to particular
                sections
                or the entire website without any notice. You acknowledge, and agree that Slash Star may
                terminate the
                authorization, rights, and license given above at any point of time at its own sole discretion.
              </p>

              <h4>Limitation of Damages:</h4>
              <p>
                In no event shall Slash Star be liable to any entity for any direct, indirect, special,
                consequential, or other damages that are related to the use of, or the inability to use,
                the content, materials, and functions of this Website or any linked Website, even if Slash Star
                is expressly advised of the possibility of such damages.
              </p>

              <h4>Termination:</h4>
              <p>
                Slash Star reserves the right, in its sole discretion, to restrict or terminate the availability
                of the Site to any
                other person, geographic area, or jurisdiction at any time. No notice is required to effect any
                such restriction or termination.
              </p>

              <h4>Third-Party Content:</h4>
              <p>
                This website furnishes third-party information including third-party articles, reports, etc. You
                acknowledge
                and agree that this third-party content is not created or endorsed by Slash Star. This
                third-party content
                is for general information only and does not recommend or suggest any marketing/branding of that
                particular
                content. You acknowledge that the third-party content is from reliable sources but there is no
                guarantee
                made by Slash Star for its completeness and accuracy.
              </p>
              <p>
                Because of the use of third-party content, you may be directed to other websites. If you decide
                to
                visit other sites, it is solely at your own discretion and responsibility to take protective
                measures to guard against viruses or such destructive elements. Such links do not imply that
                our website sponsors, endorses, is affiliated or associated with, or is legally authorized to
                use any trademark, trade name, logo, or copyright symbol displayed in or accessible through the
                links.
              </p>

              <h4>No Warranties:</h4>
              <p>
                The website and the material content provided on this site or any software available on this
                site,
                are provided 'as is' without any representation or warranty. There is no warranty of any kind,
                express
                or implied, regarding third-party content. In spite of Slash Star's best activities, there is no
                guarantee that this website will be free of viruses.
              </p>

              <h4>Changes:</h4>
              <p>
                Slash Star reserves the right, at its sole discretion, to modify or add any content of
                the Terms of Use either partially or on the whole. We also hold the full right
                to discontinue or limit the usage of your access to the website or any of its content, without
                any notice.
              </p>

              <h4>Copyright Notice:</h4>
              <p>Copyright © 2024 Slash Star. All rights reserved</p>

              <h4>Contact Information:</h4>
              <p>
                If you have any questions regarding these Terms and Conditions, please contact{" "}
                <a href="mailto:info@slashstar.co">info@slashstar.co</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
